export function parseErrors(errors: any): object {
  const errs = errors.reduce((acc: any, val: any) => {
    acc[val.field] = val.error;
    return acc;
  }, {});

  return errs;
}

export const parseErrorMsg = (error) => {
  const message = JSON.parse(JSON.stringify(error.response.errors[0].message));
  return message.split(':')[1];
};
